import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { PHIAudit } from './phi-audit/PHIAudit';

export class PHIAuditTab extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectPHIAudit: PropTypes.object,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;

    actions.loadProjectPHIAudit({ projectId, version });
  }

  render() {
    const { appSetting, actions, match, projectPHIAudit } = this.props;
    const { projectDetail } = appSetting;
    const { projectId, version } = match.params;

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab="phiAudit" projectDetail={projectDetail} />
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <PHIAudit
            projectId={projectId}
            version={version}
            actions={actions}
            audit={projectPHIAudit}
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    projectPHIAudit: state.appSetting.projectPHIAudit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PHIAuditTab);
